const dlsAcfJcamp = `
##TITLE=
##JCAMP-DX=5.0
##DATA TYPE=LINK
##BLOCKS=1
$$ === CHEMSPECTRA SPECTRUM ORIG ===
##TITLE=
##JCAMP-DX=5.00
##DATA TYPE=DLS ACF
##DATA CLASS=XYDATA
##$CSCATEGORY=SPECTRUM
##ORIGIN=
##OWNER=
##XUNITS=Lag time (microseconds)
##YUNITS=ACF (a.u.)
##XFACTOR=1.0
##YFACTOR=1.0
##FIRSTX=0.5
##LASTX=1660.0
##MAXX=1660.0
##MAXY=0.905
##MINX=0.5
##MINY=0.007
##NPOINTS=70
##XYDATA= (XY..XY)
0.5, 0.897
1.0, 0.905
1.5, 0.903
2.0, 0.9
2.5, 0.899
3.0, 0.897
3.5, 0.895
4.0, 0.892
4.5, 0.891
5.5, 0.886
6.5, 0.883
7.5, 0.879
8.5, 0.874
9.5, 0.87
10.5, 0.867
11.5, 0.863
12.5, 0.859
14.5, 0.851
16.5, 0.843
18.5, 0.834
20.5, 0.827
22.5, 0.821
24.5, 0.813
26.5, 0.806
28.5, 0.799
32.5, 0.784
36.5, 0.771
40.5, 0.757
44.5, 0.743
48.5, 0.73
52.5, 0.717
56.5, 0.704
60.5, 0.692
68.5, 0.667
76.5, 0.644
84.5, 0.622
92.5, 0.6
101.0, 0.58
109.0, 0.56
117.0, 0.541
125.0, 0.522
141.0, 0.487
157.0, 0.454
173.0, 0.425
189.0, 0.397
205.0, 0.37
221.0, 0.346
237.0, 0.324
253.0, 0.303
285.0, 0.266
317.0, 0.233
349.0, 0.205
381.0, 0.18
413.0, 0.159
445.0, 0.141
477.0, 0.124
509.0, 0.11
573.0, 0.0857
637.0, 0.068
701.0, 0.054
765.0, 0.0434
829.0, 0.0341
893.0, 0.027
957.0, 0.0221
1020.0, 0.018
1150.0, 0.0123
1280.0, 0.0105
1400.0, 0.0107
1530.0, 0.00919
1660.0, 0.007
$$ === CHEMSPECTRA INTEGRALS AND MULTIPLETS ===
##$OBSERVEDINTEGRALS= (X Y Z)
##$OBSERVEDMULTIPLETS=
##$OBSERVEDMULTIPLETSPEAKS=
$$ === CHEMSPECTRA SIMULATION ===
##$CSSIMULATIONPEAKS=
##END=


$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=
##JCAMP-DX=5.00
##DATA TYPE=DLS ACFPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=EDIT_PEAK
##$CSTHRESHOLD=1.05
##MAXX=1660.0
##MAXY=0.905
##MINX=0.5
##MINY=0.007
##$CSSOLVENTNAME=
##$CSSOLVENTVALUE=0
##$CSSOLVENTX=0
##NPOINTS=0
##PEAKTABLE= (XY..XY)
##END=


$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=
##JCAMP-DX=5.00
##DATA TYPE=DLS ACFPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=AUTO_PEAK
##$CSTHRESHOLD=1.05
##MAXX=1660.0
##MAXY=0.905
##MINX=0.5
##MINY=0.007
##NPOINTS=0
##PEAKTABLE= (XY..XY)
##END=

##END=

`;
export default dlsAcfJcamp;
